import {
  MenuOutlined,
  DownOutlined
} from '@ant-design/icons';
import { Collapse } from 'antd'
import { Button, Drawer } from 'antd';
import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { IHeaderItems } from '../Header/types';
const { Panel } = Collapse;

function index(props: {items: IHeaderItems[], logOut: () => void}) {

  const [visible, setVisible] = useState(false);
  const [itemVisible, setItemVisible] = useState<number | null>(null);

  useEffect(() => {
    setVisible(false)
  },[window.location.pathname])

  return (
    <div className="mobile-header-menu mobile-visible">
      <meta name="viewport" content="width=device-width, scale=1"/>
      <MenuOutlined onClick={() => setVisible(!visible)} style={{color: '#FFF', fontSize: '22px'}}/>
      <Drawer className="mobile-header-menu__drawer" title="Navigation" placement="right" onClose={() => setVisible(false)} open={visible}>
        {props.items.map((item: any, i: number) => (
          <Fragment key={item.name}>
          <div className="mobile-header-menu__drawer__inner">
            {item.childs && item.name !== 'Reports'? (
              <div key={item.name +"1"+i.toString()} className="mobile-header-menu__drawer__inner__item--has-child">
                <div onClick={() => setItemVisible(i === itemVisible ? null : i)} id={item.name+"button"} className="mobile-header-menu__drawer__inner__item">
                  {item.name} <span className={`arrow ${i === itemVisible && 'arrow--active'}`}><DownOutlined /></span>
                </div>
                {item.childs.map((child: any) => (
                  <Link className={`mobile-header-menu__drawer__inner__item__link ${i === itemVisible && 'mobile-header-menu__drawer__inner__item__link--active'}`} to={child.link}><div id={`submenu_${child.name}`}>{child.name}</div></Link>
                ))}
              </div>
            ):(
              <div key={item.name + "2" + i.toString()} className="mobile-header-menu__drawer__inner__item--accounts">
                <Link className="mobile-header-menu__drawer__inner__item__link" to={item.name !== 'Reports' ? item.link : '/reports'}><div id={item.name+"div"}>{item.name}</div></Link>
              </div>
            )}
          </div>
        </Fragment>
        ))}
        <div className="mobile-header-menu__drawer__inner__item--accounts">
          <div style={{textAlign: 'right'}} onClick={() => props.logOut()} id='LogOut' className="mobile-header-menu__drawer__inner__item__link">LogOut</div>
        </div>
      </Drawer>
    </div>
  )
}

export default index